export const { useDispatch, useSelector, useStore, Provider } =
  WPTB.modules.ReactRedux;
